export default __webpack_public_path__ + "static/placeholder-07497848fd9f6cdfefc99d5d6878c786.webp";